export default function createResizeObserver () {
  const listeners = [];
  (function () {
    if ('ResizeObserver' in window) {
      const resizeObserver = new window['ResizeObserver']((entries) => {
        const { contentRect } = entries[0];
        listeners.forEach((listener) => listener(contentRect));
      })
      resizeObserver.observe(document.body);
      return resizeObserver;
    }
    return null;
  })()
  return {
    addListener(fn) {
      if (listeners.indexOf(fn) === -1) {
        listeners.push(fn);
        return true;
      }
      return false;
    },
    removeListener(fn) {
      const index = listeners.indexOf(fn);
      if (index !== -1) {
        return listeners.splice(index, 1).length > 0;
      }
      return false;
    },
    /**
     * Immutable array of listeners.
     */
    get listeners () {
      return [...listeners]
    }
  }
}